const itemToString = item => (item ? item?.label ?? item : '')
const getFilteredItems = (items, selected) => {
  if (Array.isArray(selected)) {
    return items.filter(item => selected.indexOf(item) < 0)
  }

  return items.filter(item => item !== selected)
}

export { itemToString, getFilteredItems }
